import React from 'react';
import './index.scss'
import { envConfig } from '@/config/common';

function SettleIn() {
  const handleLogin = () => {
    const prefix = location.protocol + '//' + envConfig.SERVICE_SECOND_DOMAIN
    location.href = prefix + '#/sys/login'
  }
  return (
    <>
      <div className="settle-in-container">
        <div className="settle-in-title">笨鸟商城入驻流程</div>
        <div className="settle-in-process">
          <div className="process-item">
            <div className="item-title">
              <div className="title-num">01</div>
              <div className="title-text">准备资料</div>
            </div>
            <div className="item-step">
              <div className="step-num">01</div>
              <div className="step-desc">查看<a href='/#/website/qualification'>所需入驻资料</a>，不同店铺类型所需资料不同</div>
            </div>
            <div className="item-step">
              <div className="step-num">02</div>
              <div className="step-desc">建议查看所需资料，以便入驻审批一次性完成</div>
            </div>
          </div>
          <div className="process-item">
            <div className="item-title">
              <div className="title-num">02</div>
              <div className="title-text">准备资料</div>
            </div>
            <div className="item-step">
              <div className="step-num">01</div>
              <div className="step-desc">选择店铺类型，以及主营类目（约1秒钟）</div>
            </div>
            <div className="item-step">
              <div className="step-num">02</div>
              <div className="step-desc">根据页面上传相关资质，填写入驻信息（约一分钟）</div>
            </div>
            <div className="item-step">
              <div className="step-num">03</div>
              <div className="step-desc">填写您的店铺名称（约10秒钟）</div>
            </div>
          </div>
          <div className="process-item">
            <div className="item-title">
              <div className="title-num">03</div>
              <div className="title-text">审批通知</div>
            </div>
            <div className="item-step">
              <div className="step-num">01</div>
              <div className="step-desc">审核时效：资料完成，当日审批即可完成。</div>
            </div>
            <div className="item-step">
              <div className="step-num">02</div>
              <div className="step-desc">短信通知：我们将通过短信方式通知您审批结果</div>
            </div>
          </div>
          <div className="process-item">
            <div className="item-title">
              <div className="title-num">04</div>
              <div className="title-text">开店运营</div>
            </div>
            <div className="item-step">
              <div className="step-num">01</div>
              <div className="step-desc">审核通过后，可通过账号或者手机号码登录<a href='#' onClick={handleLogin}>商家管理后台</a></div>
            </div>
            <div className="item-step">
              <div className="step-num">02</div>
              <div className="step-desc">建议查看所需资料，以便入驻审批一次性完成</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SettleIn;
